import { getArtigosRecentes } from "@/lib/blog.functions";
import { createFileRoute } from "@tanstack/react-router";

import { JsonLd } from "@/components/seo/JsonLd";
import { MassaMuscular, faq } from "@/components/itv/pages/MassaMuscular";
import { carregarPaginaSimples } from "@/lib/pagina-simples";
import { getSiteData } from "@/lib/site-data.functions";
import {
  breadcrumbSchema,
  faqSchema,
  medicalWebPageSchema,
  physicianSchema,
  type Trilha,
} from "@/lib/schema";

const PATH = "/tratamentos/massa-muscular/";
const TITLE = "Ganho de Massa Muscular e Sarcopenia | Dr. Thiago Viana";
const DESCRIPTION =
  "Tratamento médico focado em hipertrofia e combate à sarcopenia, com análise de força, nutrição ajustada, bioimpedância e suporte médico contínuo.";

export const Route = createFileRoute("/tratamentos/massa-muscular")({
  loader: async () => {
    const [site, head, artigos] = await Promise.all([getSiteData(), carregarPaginaSimples(PATH, TITLE, DESCRIPTION), getArtigosRecentes()]);
    return { site, artigos, ...head };
  },
  staticData: { declaraPhysician: true },
  head: ({ loaderData }) => ({
    meta: loaderData?.meta ?? [],
    links: loaderData?.links ?? [],
  }),
  component: Page,
});

function Page() {
  const { site, artigos } = Route.useLoaderData();
  const trilha: Trilha[] = [
    { nome: "Home", path: "/" },
    { nome: "Tratamentos", path: "/tratamentos/" },
    { nome: "Massa muscular e sarcopenia", path: PATH },
  ];

  return (
    <>
      <MassaMuscular artigos={artigos} />
      <JsonLd data={medicalWebPageSchema({ path: PATH, title: TITLE, description: DESCRIPTION })} />
      <JsonLd data={breadcrumbSchema(trilha)} />
      <JsonLd data={faqSchema(faq)} />
      <JsonLd data={physicianSchema(site.doctor, "completa")} />
    </>
  );
}
